import React from 'react';

const ChevronIcon = ({ direction = 'left' }) => {
    const getPoints = () => {
        switch (direction) {
            case 'up':
                return "18 15 12 9 6 15";
            case 'down':
                return "6 9 12 15 18 9";
            case 'left':
                return "15 18 9 12 15 6";
            case 'right':
                return "9 18 15 12 9 6";
            default:
                return "15 18 9 12 15 6";
        }
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        >
            <polyline points={getPoints()} />
        </svg>
    );
};

export default ChevronIcon;
